
export default class BookingConfirmationDocument {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.createdAt = apiResponse.createdAt ? new Date(apiResponse.createdAt) : null;
        this.updatedAt = apiResponse.updatedAt ? new Date(apiResponse.updatedAt) : null;
        this.emailSentAt = apiResponse.emailSentAt ? new Date(apiResponse.emailSentAt) : null;
        this.fileUrl = apiResponse.fileUrl;
        this.downloadFileUrl = apiResponse.downloadFileUrl;
        this.pdfStatus = apiResponse.pdfStatus;
        this.emailStatus = apiResponse.emailStatus;
    }

    clone() {
        const document = new BookingConfirmationDocument({});
        document.id = this.id;
        document.createdAt = this.createdAt ? new Date(this.createdAt) : null;
        document.updatedAt = this.updatedAt ? new Date(this.updatedAt) : null;
        document.emailSentAt = this.emailSentAt ? new Date(this.emailSentAt) : null;
        document.fileUrl = this.fileUrl;
        document.downloadFileUrl = this.downloadFileUrl;
        document.pdfStatus = this.pdfStatus;
        document.emailStatus = this.emailStatus;
        return document;
    }
}